/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import LdsImage from "../components/LdsImage";
import LdsTile from "../components/LdsTile";
import LdsLink from "../components/LdsLink";
import LdsCard from "../components/LdsCard";
import homeHero from "../assets/home/homehero.png";
import microscope from "../assets/home/microscope.svg";
import brain from "../assets/home/brain.svg";
import clipboard from "../assets/home/clipboard_icon.svg";
import LdsHero from "../components/LdsHero";
import References from "../components/References";

// services
import {
  useGetUserModuleQuery,
  useResumeTrainingMutation,
} from "../store/services/moduleServerApi";

// hero image
const heroImage = [{ srcset: homeHero }];

const Home = () => {
  const navigate = useNavigate();

  // start state
  const [skipGetUserModuleQuery, setSkipGetUserModuleQuery] = useState(false);

  // start service call
  const [
    resumeTraining,
    {
      status,
      data: { data: { lastLockedSlide = "/module-1/overview" } = {} } = {},
    },
  ] = useResumeTrainingMutation();
  if (status === "fulfilled") {
    navigate(lastLockedSlide);
  }

  const { data: { data = [] } = {} } = useGetUserModuleQuery(null, {
    skip: !sessionStorage.getItem("token") || skipGetUserModuleQuery,
  });
  console.log("data :>> ", data);
  const isActivePointerEventForModule2 = data.some(
    ({ module, completed }) => ~~module === 1 && completed
  );
  const isActivePointerEventForModule3 = data.some(
    ({ module, completed }) => ~~module === 2 && completed
  );

  console.log(
    "isActivePointerEventForModule2, isActivePointerEventForModule3 :>> ",
    isActivePointerEventForModule2,
    isActivePointerEventForModule3
  );

  // custom function
  const handleModuleTraining = (moduleNo) => {
    if (!sessionStorage.getItem("token")) {
      return navigate("/login");
    }
    setSkipGetUserModuleQuery(true);
    resumeTraining(moduleNo);
  };

  return (
    <main>
      <section className="mt-5 mb-5">
        <div className="">
          <LdsHero
            layout="half-billboard"
            layoutImagePosition="right"
            images={heroImage}
            alt="Older woman with text: 'It's hard to tell from the outside. Amyvid can help,' highlighting symptoms like worsening memory and misplacing items. The Amyvid logo is displayed at the top left."
            classNameWrapper=""
            classNameSection="home-hero container"
            imageRenderMode="contain"
            contentColumnClasses="col col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 order-md-1"
            classNameImageColumn="col col-12 col-md-6 col-lg-6 col-xl-4 col-xxl-5 order-md-2"
            classNameImageWrapper="container"
          >
            {
              <>
                <p className="fz-display b trade pt-4">
                  <span className="orange">
                    IT’S HARD TO TELL FROM
                    <br />
                    THE OUTSIDE.
                  </span>
                  <br />
                  <span className="blue">
                    AMYVID CAN HELP.<sup>1</sup>
                  </span>
                </p>

                <LdsLink
                  onClick={() => handleModuleTraining(1)}
                  href="#"
                  ariaLabel="Start Amyvid training now"
                  classes="orange-button d-inline-block mt-0 mb-3"
                >
                  Start Training Now
                </LdsLink>
              </>
            }

            <div className="mt-0">
              <p className="mb-1 fz-sm">
                Amyvid is a diagnostic imaging agent for estimating beta-amyloid neuritic plaque density.<sup>2</sup>
              </p>
            </div>
          </LdsHero>
        </div>
      </section>

      <LdsTile role="group" ariaLabel="Reader Training">
        <div className="section pt-5">
          <div className="container">
            <div className="row">
              <div className="col-md-8 offset-md-2">
                <div>
                  <p className="text-center mt-0 mb-4">
                    Amyvid is used to estimate beta-amyloid neuritic plaque density in adult patients with cognitive
                    impairment who are being evaluated for Alzheimer’s disease and other causes of cognitive
                    decline. Amyvid is an adjunct to other diagnostic evaluations.<sup>2</sup>
                  </p>
                  <h1 className="text-uppercase text-center b h1 mb-4">CORE READING TRAINING</h1>
                  <p>
                    Amyvid Reader Training is primarily designed to enhance your proficiency in interpreting Amyvid scans.
                  </p>
                  <p>
                    Amyvid images should be interpreted only by readers who
                    successfully complete the Amyvid Reader Training.
                  </p>
                </div>
                <div className="row justify-content-center homepage-module-cards mt-5">
                  <div className="col col-12 col-md-4 d-flex">
                    <LdsCard grow >
                      <a
                        onClick={() => handleModuleTraining(1)}
                        href="#"
                        className="text-decoration-none"
                        title="Module 1"
                      >
                        <LdsCard.Body>
                          <h4 className="b">Module 1</h4>
                          <p>
                            Learn about Alzheimer's disease (AD), its underlying
                            neuropathology, and the role of Amyvid.
                          </p>
                        </LdsCard.Body>
                        <LdsCard.Footer>
                          <p className="b">4 Sections</p>
                          <LdsImage
                            src={microscope}
                            alt="Microscope"
                            style={{
                              maxHeight: "100px",
                              alignSelf: "center",
                            }}
                          />
                        </LdsCard.Footer>
                      </a>
                    </LdsCard>
                  </div>
                  <div
                    className={`col col-12 col-md-4 d-flex ${isActivePointerEventForModule2 === false
                      ? " disable-pointer-events"
                      : ""
                      }`}
                    style={{
                      pointerEvents:
                        isActivePointerEventForModule2 === false ? "none" : "",
                    }}
                  >
                    <LdsCard grow>
                      <a
                        onClick={() => handleModuleTraining(2)}
                        href="#"
                        className="text-decoration-none"
                        title="Module 2"
                      >
                        <LdsCard.Body>
                          <h4 className="b">Module 2</h4>
                          <p>
                            Learn the key anatomy, steps, and interpretation
                            criteria for Amyvid PET images.
                          </p>
                        </LdsCard.Body>
                        <LdsCard.Footer>
                          <p className="b">3 Sections</p>
                          <LdsImage
                            src={brain}
                            alt="Illustrainon of a human brain"
                            style={{
                              maxHeight: "100px",
                              alignSelf: "center",
                            }}
                          />
                        </LdsCard.Footer>
                      </a>
                    </LdsCard>
                  </div>
                  <div
                    className={`col col-12 col-md-4 d-flex ${isActivePointerEventForModule3 === false
                      ? " disable-pointer-events"
                      : ""
                      }`}
                  >
                    <LdsCard grow>
                      <a
                        onClick={() => handleModuleTraining(3)}
                        href="#"
                        className="text-decoration-none"
                        title="Module 3"
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <LdsCard.Body>
                          <h4 className="b">Module 3</h4>
                          <p>
                            Put your knowledge to the test with real case
                            studies.
                          </p>
                        </LdsCard.Body>
                        <LdsCard.Footer>
                          <p className="b">20 Case studies</p>
                          <LdsImage
                            src={clipboard}
                            alt="Illustration of clipboard"
                            style={{
                              maxHeight: "100px",
                              alignSelf: "center",
                            }}
                          />
                        </LdsCard.Footer>
                      </a>
                    </LdsCard>
                  </div>
                  <div className="container row justify-center">
                    <p className="mt-5 text-center col">
                      Please note: Amyvid Reader Training must be completed in
                      sequential order. After you complete each module, the next
                      will become available. Completed modules can be revisited
                      at any time. The entire Core Reader Training program will
                      take approximately 2 to 3 hours to complete.
                    </p>
                  </div>
                  <div className="row justify-center">
                    <div className="mt-5 text-center">
                      <LdsLink
                        onClick={() => handleModuleTraining(1)}
                        href="#"
                        ariaLabel="Start Amyvid training now"
                        classes="blue-button alignCenter"
                      >
                        Start Training Now
                      </LdsLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LdsTile>
      <div className="mt-5">
        <div className="container">
          <References>
            <ol className="no-indent mt-2 fz-sm gray">
              <li>
                Clark CM, Schneider JA, Bedell BJ, et al; for the AV45-A07 Study Group. Use of florbetapir-PET for imaging <em>β-amyloid</em> pathology. <em>JAMA.</em> 2011;305(3):275-283.
              </li>
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.
              </li>
              <li>
                Gauthier S, Rosa-Neto P, Morais JA, et al. World Alzheimer Report 2021: Journey Through the Diagnosis of Dementia. London, England: Alzheimer’s Disease International; 2021. Accessed January 25, 2023. https://www.alzint.org/u/World-Alzheimer-Report-2021.pdf
              </li>
              <li>
                DiBenedetti DB, Slota C, Wronski SL, et al. Assessing what matters most to patients with or at risk for Alzheimer’s and care partners: a qualitative study evaluating symptoms, impacts, and outcomes. <em>Alzheimers Res Ther.</em> 2020;12(1):90.
              </li>
            </ol>
          </References>
        </div>
      </div>
    </main>
  );
};

export default Home;
